<template>
  <section
    v-if="visible"
    ref="coach"
    class="soc-step-coach sap-card"
    data-testid="soc-step-coach"
  >
    <div class="soc-step-coach__badge">{{ badgeText }}</div>
    <h3 class="soc-step-coach__title">{{ title }}</h3>
    <p v-if="hint" class="soc-step-coach__hint">{{ hint }}</p>
    <div class="soc-step-coach__actions">
      <slot>
        <el-button
          v-for="(a, i) in actions"
          :key="a.id || ('a-' + i)"
          :type="a.type || (i === 0 ? 'primary' : 'default')"
          :size="buttonSize"
          :disabled="!!a.disabled"
          @click="$emit('action', a)"
        >{{ a.label }}</el-button>
      </slot>
    </div>
  </section>
</template>

<script>
/**
 * SOC 流程教練卡（金樣 · Steven 2026-09-14）
 * 步驟條下方：現在請做第 N 步 + 大按鈕；禁止客戶在整頁大海撈針。
 * SSOT: docs/product/SOC_PIPELINE_UI_GOLDEN_SSOT.md
 */
export default {
  name: 'SocStepCoach',
  props: {
    visible: { type: Boolean, default: true },
    stepNumber: { type: Number, default: 1 },
    title: { type: String, default: '' },
    hint: { type: String, default: '' },
    badge: { type: String, default: '' },
    actions: { type: Array, default: function () { return [] } },
    buttonSize: { type: String, default: 'medium' },
    scrollOnShow: { type: Boolean, default: true }
  },
  computed: {
    badgeText: function () {
      if (this.badge) return this.badge
      return '現在請做 · 第 ' + this.stepNumber + ' 步'
    }
  },
  watch: {
    visible: function (v) {
      if (v) this.scrollIntoViewSoft()
    },
    stepNumber: function () {
      this.scrollIntoViewSoft()
    }
  },
  mounted: function () {
    this.scrollIntoViewSoft()
  },
  methods: {
    scrollIntoViewSoft: function () {
      if (!this.scrollOnShow) return
      var self = this
      this.$nextTick(function () {
        var el = self.$refs.coach
        if (el && el.scrollIntoView) {
          try {
            el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
          } catch (e) {
            el.scrollIntoView(true)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.soc-step-coach {
  margin: 0 0 0;
  padding: 14px 16px;
  border: 2px solid var(--sap-color-primary, #0070f2);
  box-shadow: 0 0 0 3px rgba(0, 112, 242, 0.18);
  background: #f5faff;
  border-radius: 8px;
}
.soc-step-coach__badge {
  display: inline-block;
  margin-bottom: 6px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: var(--sap-color-primary, #0070f2);
}
.soc-step-coach__title {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 700;
  color: var(--sap-color-text, #1d2d3e);
}
.soc-step-coach__hint {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--sap-color-text-secondary, #556b82);
}
.soc-step-coach__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SocStepCoach.vue